<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card class="overflow-hidden" card-background="primary"
               content-color="#fff">
        <div slot="no-body">
          <div class="p-6 flex items-center">
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">{{counts.total_my_request}}</h2>
              <span>Demandes</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card class="overflow-hidden" card-background="success" content-color="white">
        <div slot="no-body">
          <div class="p-6 flex justify-between items-center">
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">{{counts.total_closed_request}}</h2>
              <span>Demandes clôturées</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div class="p-6 flex justify-between items-center">
            <div class="truncate">
              <h2 class="mb-1 font-bold">{{counts.total_on_treat}}</h2>
              <span>En cours de traitement</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card class="overflow-hidden" card-background="danger" content-color="white">
        <div slot="no-body">
          <div class="p-6 flex justify-between items-center">
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">{{counts.total_rejected_request}}</h2>
              <span>Demandes rejetées</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

  </div>
</template>

<script>
  export default {
    name: "counts",
    data: () => ({
      counts: {
        total_my_request: 0,
        total_closed_request: 0,
        total_rejected_request: 0,
        total_on_treat: 0
      }
    }),
    methods:{
      getRequestsCount(){
          this.$vs.loading()
          this.$http.get('statistics/cc').then((response) => {
            this.counts = response.data
            this.$vs.loading.close()
          }).catch((error) => {
            this.$vs.loading.close()
            if (error.response.status === 401) {
              this.$vs.notify({
                title: 'Erreur',
                text: 'Votre session a expiré',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-check',
                position: 'top-right'
              })
              this.$router.push({name: "login"})
            }
          })
      }
    },
    mounted() {
      this.getRequestsCount()
    }
  }
</script>

<style scoped>

</style>
